import { getLoaderCSS } from '../css';
export const loaderComponentHtml = ({ nonce, text, }) => `
        <div class='preloader spinner'>
            <style ${nonce ? `nonce="${nonce}"` : ''}>
              ${getLoaderCSS()}
            </style>

            <div class='ui big active loader'>
              ${text
    ? `<div class='content'>
                      <div class='ui text loader'>
                        ${text}
                      </div>
                    </div>`
    : ''}
            </div>
        </div>
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9sb2FkZXIvaHRtbC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sUUFBUSxDQUFDO0FBRXRDLE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHLENBQUMsRUFDbEMsS0FBSyxFQUNMLElBQUksR0FJTCxFQUFFLEVBQUUsQ0FBQzs7cUJBRWUsS0FBSyxDQUFDLENBQUMsQ0FBQyxVQUFVLEtBQUssR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFO2dCQUNwQyxZQUFZLEVBQUU7Ozs7Z0JBS2QsSUFBSTtJQUNGLENBQUMsQ0FBQzs7MEJBRU0sSUFBSTs7MkJBRUg7SUFDVCxDQUFDLENBQUMsRUFDTjs7O0NBR2IsQ0FBQyJ9